import { useTranslation } from 'react-i18next';
import { ApiError } from './api';

/**
 * Traduce il codice di errore restituito dall'API. L'API non manda mai testo
 * rivolto all'utente: la stringa nasce sempre qui, dai file di localizzazione.
 */
export function useErrorMessage(): (error: unknown) => string | null {
  const { t } = useTranslation();

  return (error: unknown): string | null => {
    if (!error) return null;
    const code = error instanceof ApiError ? error.code : 'internal_error';
    return t(`errors.${code}`, { defaultValue: t('errors.internal_error') });
  };
}
